module.exports = __webpack_public_path__ + "static/img/VA.74a3ba52.jpg";